
export const getLocale = (lang, country) => {
    if (lang === 'en') return 'en-GB';

    if (!country) {
        try {
            if (typeof window !== 'undefined' && localStorage) {
                let ctr = localStorage?.getItem?.('country');
                let countryTwoLetter = localStorage?.getItem?.('countryTwoLetter');
                if (ctr && ['sweden', 'denmark'].includes(ctr)) country = ctr;
                else if (ctr === 'uk') {
                    if (countryTwoLetter === 'gb') country = 'uk';
                    else if (countryTwoLetter === 'ch') country = 'ch';
                    else if (countryTwoLetter === 'gr') country = 'gr';
                    else if (countryTwoLetter === 'es') country = 'es';
                    else if (countryTwoLetter === 'ae') country = 'ae';
                }
            }
        } catch (err) { }
    }

    switch (country) {
        case 'sweden': return 'sv-SE';
        case 'denmark': return 'da-DK';
        case 'uk': return 'en-GB';
        case 'ch': return 'de-CH';
        case 'gr': return 'el-GR';
        case 'es': return 'es-ES';
        case 'ae': return 'ar-AE';
    }

    return 'en-GB';
}